/* @flow */

import React from 'react';
import Globals from '../../constants/Globals';

type $Props = {
  message: ?string,
  oneweb?: boolean,
  modifierClass?: string
};

const UnsupportedBrowser = (props: $Props) => {

  const getClassName = () => {
    const cn: Array<string> = [ 'dlc-unsupported' ];
    if (props.oneweb) cn.push('dlc-spa-oneweb');
    if (props.modifierClass) cn.push(props.modifierClass);
    return cn.join(' ');
  }

  return (
    <div className={ getClassName() }>
      { props.message || Globals.UNSUPPORTED_BROWSER_WARNING }
    </div>
  );
}

export default UnsupportedBrowser;
